module.exports = __webpack_public_path__ + "assets/img/Type E (26).e37626d8.jpg";